import type { IPasswordResetDto, IPasswordResetResponse } from "./types";
import type { IPathBaseParam } from "./path";

import { setPassword } from "@api/auth/passwordReset/setPassword/api";
import { verify } from "@api/auth/passwordReset/verify/api";
import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IPasswordResetResponse>,
  IPathBaseParam,
  IPasswordResetDto
>("auth.passwordReset");

export const passwordReset = {
  ...postApis,
  setPassword,
  verify,
};
